import { InjectionToken } from '@angular/core';

export interface AnalyticWindow extends Window {
  dataLayer: Array<Record<string, any> | string>;
}

export const ANALYTICS_WINDOW = new InjectionToken('ANALYTICS_WINDOW');
